<template>
    <radio-checkbox-collection 
        :enabled-options="supportedTagRouteTypes" 
        :options="[{
            value: TAG_TYPES.GOAL,
            label: resource('JourneyBuilder_Sankey_Goal_Label')
        }, {
            value: TAG_TYPES.OUTFLOW,
            label: resource('JourneyBuilder_Sankey_Outflow_Label')
        }]"
        v-model="valueModel"
    />
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

import TAG_TYPES from './tag-route-types';
import resourceMixin from "@core/Util/Mixins/resources";
import RadioCheckboxCollection from "./RadioCheckboxCollection";

const { mapState, mapGetters, mapMutations } = createNamespacedHelpers('journeyBuilder/reporting');

//https://datanext.atlassian.net/browse/DPN-3390?focusedCommentId=58195
/*
{
    value: TAG_TYPES.OUTFLOW,
    label: resource('JourneyBuilder_Sankey_Outflow_Label')
}
 */

export default {
    name: "TagRouteSelector",

    components: {
        RadioCheckboxCollection
    },

    mixins: [resourceMixin],

    data() {
        return {
            TAG_TYPES
        }
    },

    computed: {
        ...mapState(['tagRouteType']),
        ...mapGetters(['supportedTagRouteTypes']),
        valueModel: {
            set(value) {
                this.setTagRouteType(value);
            },
            get() {
                return this.tagRouteType;
            }
        }
    },

    watch: {
        supportedTagRouteTypes(value) {
            //Reset when our selected type becomes unavailable
            if(
                this.valueModel &&
                !value.includes(this.valueModel)
            ) {
                this.valueModel = undefined;
            }
        }
    },
    
    created() {
        //Show goals by default
        this.setTagRouteType(TAG_TYPES.GOAL);
    },

    methods: {
        ...mapMutations(['setTagRouteType'])
    }
}
</script>

<style scoped lang="scss">
.option {
    display: inline-block;

    &:not(:first-child){
        padding-left: 10px;
    }
}
</style>